import { includes, keyBy, omit, cloneDeep } from 'lodash';
import coveredWarrantService from '../../../core/services/Market/Watchlist/CoveredWarrantService';
import {
  deleteUserWatchlist,
  updateUserWatchlist,
} from '../../app/commonReducer';
import EventEmitter, { SET_ERROR } from '../../helpers/EventEmitter';
import {
  callApiSystemSetting,
  getUserSettingState,
  getWatchlistUserSetting,
} from '../../main-layout/sidebar/reducer';
import {
  addCoveredWarrant,
  removeCoveredWarrant,
  resetCWData,
} from './covered-warrant/reducer';
import ConstSummary from './summary/Const';
import ConstNews from './news/Const';
import Const from './Const';
import ConstCommon from './../../common/Const';
import summaryService from '../../../core/services/Market/Watchlist/SummaryService';
import newsService from '../../../core/services/Market/Watchlist/NewsService';
import {
  getDataFollowKeyByDot,
  getQueryParams,
  isNotLogin,
  setDataFollowKeyByDot,
} from './../../helpers/Common';
import reducerRegistry from './../../helpers/ReducerRegistry';
import request from './../../helpers/Request';
import Interval from '../../../component/helpers/IntervalCallApi';
import chartService from '../../../core/services/Market/Watchlist/ChartService';
import registerCancelTokenAxios from './../../helpers/RegisterCancelTokenAxios';
import userSettingService from './../../../core/services/Common/UserSettingService';
import { formatData } from './../../helpers/Api';
import currentState from './../../helpers/CurrentState';
import { groupBy } from '../../helpers/ArrayUtils';
import { I18n } from 'react-redux-i18n';

import { formatDate } from '../../helpers/FormatDate';
import { REDUCER_NAME as CW_REDUCER_NAME } from './covered-warrant/reducer';

const REDUCER_NAME = 'WATCH_LIST:';
const CHANGE_TAB = `${REDUCER_NAME}CHANGE_TAB`;
const FETCH_LIST_SUMMARY = `${REDUCER_NAME}FETCH_LIST_SUMMARY`;
const CHANGE_CURRENT_DATA = `${REDUCER_NAME}CHANGE_CURRENT_DATA`;
const FETCH_LIST_DERIVATIVE = `${REDUCER_NAME}FETCH_LIST_DERIVATIVE`;
const UPDATE_LIST_DERIVATIVE = `${REDUCER_NAME}UPDATE_LIST_DERIVATIVE`;
const FETCH_LIST_PUT_THROUGH = `${REDUCER_NAME}FETCH_LIST_PUT_THROUGH`;
const FETCH_COVERED_WARRANT = `${REDUCER_NAME}FETCH_COVERED_WARRANT`;
const CREATE_WATCH_LIST = `${REDUCER_NAME}CREATE_WATCH_LIST`;
const FETCH_MY_WATCH_LIST = `${REDUCER_NAME}FETCH_MY_WATCH_LIST`;
const CHANGE_WATCH_LIST_ID = `${REDUCER_NAME}CHANGE_WATCH_LIST_ID`;
const FETCH_LIST_NEWS = `${REDUCER_NAME}FETCH_LIST_NEWS`;
const LOAD_MORE_NEWS = `${REDUCER_NAME}LOAD_MORE_NEWS`;
const FETCH_DATA = `${REDUCER_NAME}FETCH_DATA`;
const CHANGE_TREND_INDEX = `${REDUCER_NAME}CHANGE_TREND_INDEX`;
const RENDER_PERFORMANCE_CHART = `${REDUCER_NAME}RENDER_PERFORMANCE_CHART`;
const UPDATE_MY_INDEX = `${REDUCER_NAME}UPDATE_MY_INDEX`;
const DELETE_MY_INDEX = `${REDUCER_NAME}DELETE_MY_INDEX`;
const CHANGE_LIST_HIDE_COLUMN_INDEX = `${REDUCER_NAME}CHANGE_LIST_HIDE_COLUMN_INDEX`;
const SET_FILTER_NEW_VALUE = `${REDUCER_NAME}SET_FILTER_NEW_VALUE`;
const SET_QUERY_NEW_VALUE = `${REDUCER_NAME}SET_QUERY_NEW_VALUE`;
const SET_DATE_RANGE_OPTION = `${REDUCER_NAME}SET_DATE_RANGE_OPTION`;
const SUBSCRIBE_REALTIME_DATA = `${REDUCER_NAME}SUBSCRIBE_REALTIME_DATA`;
const ADD_TICKER = `${REDUCER_NAME}ADD_TICKER`;
const ADD_TICKER_TECHNICAL = `${REDUCER_NAME}ADD_TICKER_TECHNICAL`;
const DELETE_TICKER = `${REDUCER_NAME}DELETE_TICKER`;
const HOVER_ROW = `${REDUCER_NAME}HOVER_ROW`;

const RESIZE_COLUMN_TABLE = `${REDUCER_NAME}RESIZE_COLUMN_TABLE`;
const FETCH_DATA_PERFORMANCE_REALTIME = `${REDUCER_NAME}FETCH_DATA_PERFORMANCE_REALTIME`;

const SET_FETCHING = `${REDUCER_NAME}SET_FETCHING`;
const INITIAL_DATA_TECHNICAL = `${REDUCER_NAME}INITIAL_DATA_TECHNICAL`;
const INITIAL_DATA_SUMMARY = `${REDUCER_NAME}INITIAL_DATA_SUMMARY`;

const TOGGLE_VIEW_CHART = `${REDUCER_NAME}TOGGLE_VIEW_CHART`;
const FETCH_DATA_CHART = `${REDUCER_NAME}FETCH_DATA_CHART`;
const INITIAL_LIST_DATA_CHART = `${REDUCER_NAME}INITIAL_LIST_DATA_CHART`;
const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;
const TOGGLE_CONFIRM_POPUP_DELETE = `${REDUCER_NAME}TOGGLE_CONFIRM_POPUP_DELETE`;
const TOGGLE_CONFIRM_POPUP_CREATE_WL = `${REDUCER_NAME}TOGGLE_CONFIRM_POPUP_CREATE_WL`;

const SUBSCRIBE_REALTIME_DATA_PUT_THROUGH = `${REDUCER_NAME}SUBSCRIBE_REALTIME_DATA_PUT_THROUGH`;
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;

const CHANGE_TABLE_INDEX_SORT_STATE = `${REDUCER_NAME}CHANGE_TABLE_INDEX_SORT_STATE`;
const SET_SORTED_IDS = `${REDUCER_NAME}SET_SORTED_IDS`;

const NOTIFY_SAVE_WATCH_LIST = `${REDUCER_NAME}NOTIFY_SAVE_WATCH_LIST`;
const MAX_LENG_LIST_WATCH_LIST = 100;

const UPDATE_BID_ASK = `${REDUCER_NAME}UPDATE_BID_ASK`;

const DELETE_MY_CW = `${REDUCER_NAME}DELETE_MY_CW`;
const UPDATE_MY_CW = `${REDUCER_NAME}UPDATE_MY_CW`;

const HIDE_DELETE_POPUP = `${REDUCER_NAME}HIDE_DELETE_POPUP`;

export {
  REDUCER_NAME,
  reducer as default,
  changeTab,
  fetchListSummary,
  fetchListDerivative,
  changeIndex,
  changeDerivative,
  changePutThrough,
  fetchListPutThrough,
  createWatchList,
  fetchMyWatchList,
  fetchListNewsData,
  changeTrendIndex,
  renderPerformanceChart,
  updateCustomWatchlist,
  deleteMyIndex,
  changeListHideColumnIndex,
  setFilterNewValue,
  setDateRangeOption,
  setQueryNewValue,
  loadMoreNews,
  notifyResizeColumnTable,
  subscribeRealtimeTickData,
  intervalFetchDataPerformanceChart,
  clearIntervalFetchDataPerformanceChart,
  toggleViewChart,
  updateWatchList,
  deleteTicker,
  fetchChartImage,
  confirmDeleteTicker,
  toggleConfirmPopupDelete,
  toggleConfirmPopupCreateWatchList,
  changeIdHover,
  updateListDerivative,
  subscribeRealtimeDataPutThrough,
  changeTableIndexSortState,
  setSortedIds,
  notifySaveWatchList,
  updateBidAsk,
  fetchListCoveredWarrant,
  changeCoveredWarrant,
  deleteMyCW,
  updateCWWatchListOrganCodes,
  hideDeletePopup,
  appendTickerToWatchlist,
};

function hideDeletePopup() {
  return {
    type: HIDE_DELETE_POPUP,
  };
}

function setSortedIds(ids) {
  return {
    type: SET_SORTED_IDS,
    payload: ids,
  };
}

function updateBidAsk(data) {
  return {
    type: UPDATE_BID_ASK,
    payload: {
      data,
    },
  };
}

function subscribeRealtimeDataPutThrough(data) {
  const groupByComGroupCode = groupBy('comGroupCode');
  const listDataRealTime = groupByComGroupCode(data);
  return {
    type: SUBSCRIBE_REALTIME_DATA_PUT_THROUGH,
    payload: {
      listDataRealTime,
    },
  };
}

function clearIntervalFetchDataPerformanceChart(organCode) {
  return () => {
    Interval.cancel(organCode);
  };
}

function intervalFetchDataPerformanceChart(organCode, func) {
  return dispatch => {
    Interval.fetch(
      organCode,
      dispatch,
      source => {
        return summaryService.getTwoDaysSeries(
          { OrganCode: organCode },
          source,
        );
      },
      response => {
        func(response);
      },
      ConstSummary.performanceChart.INTERVAL_GET_DATA,
    );
  };
}

function changeTab(currentTab) {
  return (dispatch, getState) => {
    const watchListId = getState()[REDUCER_NAME].watchListId;

    currentState.add(
      ConstCommon.listComponent.Watchlist,
      'currentTab',
      currentTab,
    );

    dispatch({
      type: CHANGE_TAB,
      payload: {
        currentTab,
      },
    });
    fetchData(dispatch, currentTab, watchListId);
  };
}

function changeWatchListId(watchListId) {
  currentState.add(
    ConstCommon.listComponent.Watchlist,
    'watchListId',
    watchListId,
  );
  return {
    type: CHANGE_WATCH_LIST_ID,
    payload: {
      watchListId,
    },
  };
}

function getWatchListType(watchListId, getState) {
  const currentMyIndex = getState()[REDUCER_NAME].currentMyIndex;
  const currentDefaultIndex = getState()[REDUCER_NAME].currentDefaultIndex;
  const currentIndustry = getState()[REDUCER_NAME].currentIndustry;

  switch (watchListId) {
    case currentMyIndex:
      return Const.watchListType.CUSTOM;
    case currentDefaultIndex:
      return Const.watchListType.COMPANY_GROUP;
    case currentIndustry:
      return Const.watchListType.SECTOR;
    default:
      return Const.watchListType.CUSTOM;
  }
}

function fetchListSummary(watchListId) {
  return (dispatch, getState) => {
    dispatch(setFetching());
    dispatch({
      type: INITIAL_DATA_SUMMARY,
    });
    const watchListType = getWatchListType(watchListId, getState);

    request.fetchApi(
      params => {
        const source = registerCancelTokenAxios.register(
          ConstCommon.listComponent.Watchlist,
        );
        return summaryService.getWatchListSummary(
          {
            ...params,
            WatchListId: watchListId,
            WatchListType: watchListType,
          },
          source,
        );
      },
      data => {
        if (data) {
          hideFetching(getState, dispatch);
          dispatch({
            type: FETCH_LIST_SUMMARY,
            payload: {
              listSummary: data,
            },
          });
          dispatch({
            type: INITIAL_LIST_DATA_CHART,
          });
        }
      },
      () => {
        dispatch(setFetching(false));
      },
      () => {
        dispatch(setFetching(false));
      },
    );
  };
}

function fetchListDerivative(derivativeId) {
  return dispatch => {
    dispatch(setFetching());
    const source = registerCancelTokenAxios.register(
      ConstCommon.listComponent.Watchlist,
    );
    const then = response => {
      const items = response.items || [];
      dispatch(setFetching(false));
      dispatch({
        type: FETCH_LIST_DERIVATIVE,
        payload: {
          derivativeId,
          listDerivative: items,
        },
      });
    };
    if (derivativeId === ConstSummary.derivativeTypes.BONDS) {
      summaryService.getBonds(null, source).then(then);
    } else {
      summaryService.getWatchListDerivative(null, source).then(then);
    }
  };
}

function updateListDerivative(payload) {
  return {
    payload,
    type: UPDATE_LIST_DERIVATIVE,
  };
}

function fetchListPutThrough(putThroughId) {
  return dispatch => {
    dispatch(setFetching());
    const source = registerCancelTokenAxios.register(
      ConstCommon.listComponent.Watchlist,
    );

    summaryService.getWatchListPutThrough(null, source).then(response => {
      const items = formatData(response);
      const data = items.length > 0 ? items[0] : {};

      const { hose = [], hnx = [], upcom = [] } = data;

      dispatch(setFetching(false));
      dispatch({
        type: FETCH_LIST_PUT_THROUGH,
        payload: {
          putThroughId,
          listPutThroughUpcom: upcom,
          listPutThroughHnx: hnx,
          listPutThroughHose: hose,
        },
      });
    });
  };
}

function fetchListCoveredWarrant(coveredWarrantId) {
  return dispatch => {
    dispatch({
      type: FETCH_COVERED_WARRANT,
      payload: {
        coveredWarrantId,
      },
    });
  };
}

function changeIndex(watchListId, oldWatchListId) {
  return (dispatch, getState) => {
    const currentTab = getState()[REDUCER_NAME].currentTab;

    dispatch(changeCurrentData(oldWatchListId, watchListId));
    fetchData(dispatch, currentTab, watchListId);
  };
}

function changeCurrentData(oldWatchListId, watchListId) {
  return {
    type: CHANGE_CURRENT_DATA,
    payload: {
      oldWatchListId,
      watchListId,
    },
  };
}

function changeDerivative(derivativeId) {
  return dispatch => {
    registerCancelTokenAxios.delete(ConstCommon.listComponent.Watchlist);
    currentState.add(
      ConstCommon.listComponent.Watchlist,
      'watchListId',
      derivativeId,
    );
    dispatch(fetchListDerivative(derivativeId));
  };
}

function changePutThrough(putThroughId) {
  return dispatch => {
    registerCancelTokenAxios.delete(ConstCommon.listComponent.Watchlist);
    currentState.add(
      ConstCommon.listComponent.Watchlist,
      'watchListId',
      putThroughId,
    );
    dispatch(fetchListPutThrough(putThroughId));
  };
}

function changeCoveredWarrant(coveredWarrantId) {
  return dispatch => {
    registerCancelTokenAxios.delete(ConstCommon.listComponent.Watchlist);
    currentState.add(
      ConstCommon.listComponent.Watchlist,
      'watchListId',
      coveredWarrantId,
    );
    dispatch(fetchListCoveredWarrant(coveredWarrantId));
  };
}

function createWatchList(watchListName, type = Const.watchListType.CUSTOM) {
  return (dispatch, getState) => {
    const language = getState().i18n.locale;
    userSettingService
      .newWatchList({
        [ConstSummary.listUserWatchList.TEXT]: watchListName,
        organCodes: [],
        type,
        language,
      })
      .then(res => {
        if (res.status === ConstCommon.RESPONSE_STATUS.FAILED) {
          dispatch(
            toggleConfirmPopupCreateWatchList(
              true,
              'message.server_error',
              res.errors,
            ),
          );
        }
        if (res.status === ConstCommon.RESPONSE_STATUS.SUCCESS) {
          const newWl = {
            [ConstSummary.listUserWatchList.TEXT]: watchListName,
            organCodes: [],
            type,
            language,
            watchListId: res.result,
            typeCode: type,
          };
          dispatch(updateUserWatchlist(newWl));
          const watchListId = res.result;
          currentState.add(
            ConstCommon.listComponent.Watchlist,
            'watchListId',
            watchListId,
          );
          if (type === Const.watchListType.CUSTOM_CW) {
            dispatch(resetCWData());
          }
          dispatch({
            type: CREATE_WATCH_LIST,
            payload: {
              watchListId,
              watchListName,
              type,
            },
          });
        }
      });
  };
}

function fetchMyWatchList() {
  return (dispatch, getState) => {
    const source = registerCancelTokenAxios.register(
      ConstCommon.listComponent.Watchlist,
    );
    const user = getState().userInfo;
    userSettingService.getUserWatchList(null, source).then(({ items }) => {
      if (items) {
        const {
          listCompany,
          listSector,
          listCustom,
          listCW,
        } = getUserWatchListByTypeCode(items);

        // get watchlist id default from code
        const companyDefault = listCompany.find(
          item =>
            item[ConstSummary.listUserWatchList.CODE] ===
            ConstSummary.currentDefaultIndex,
        );

        const watchListIdDefault =
          companyDefault[ConstSummary.listUserWatchList.WATCH_LIST_ID];
        const savedWatchlistId = currentState.get(
          ConstCommon.listComponent.Watchlist,
          'watchListId',
        );
        const watchListId =
          +getQueryParams('watchListId') ||
          (savedWatchlistId && !isNotLogin(user)
            ? savedWatchlistId
            : watchListIdDefault);

        dispatch({
          type: FETCH_MY_WATCH_LIST,
          payload: {
            listCompany,
            listSector,
            listCustom,
            listCW,
            watchListIdDefault,
            watchListId,
          },
        });
        const { currentCoveredWarrant } = getState()[REDUCER_NAME];
        if (currentCoveredWarrant !== watchListId) {
          fetchData(dispatch, getState()[REDUCER_NAME].currentTab, watchListId);
        }
      }
    });
  };
}

function fetchListNewsData(params, watchListId) {
  return (dispatch, getState) => {
    const newWatchListId = watchListId
      ? watchListId
      : getState()[REDUCER_NAME].watchListId;
    const watchListType = getWatchListType(newWatchListId, getState);

    const formatParams = formatedParams(params);

    dispatch(setFetching());
    const source = registerCancelTokenAxios.register(
      ConstCommon.listComponent.Watchlist,
    );
    newsService
      .getListWatchListNews(
        {
          ...formatParams,
          WatchListId: newWatchListId,
          WatchListType: watchListType,
        },
        source,
      )
      .then(response => {
        dispatch(setFetching(false));
        const { items = [], totalCount, pageSize } = response;
        dispatch({
          type: FETCH_LIST_NEWS,
          payload: {
            listWatchListNews: items || [],
            totalCount,
            pageSize,
          },
        });
      })
      .catch(err => dispatch(setFetching(false)));
  };
}

function loadMoreNews(params, watchListId) {
  const formatParams = formatedParams(params);
  return (dispatch, getState) => {
    const newWatchListId = watchListId
      ? watchListId
      : getState()[REDUCER_NAME].watchListId;
    const watchListType = getWatchListType(newWatchListId, getState);

    dispatch(setFetching());
    const source = registerCancelTokenAxios.register(
      ConstCommon.listComponent.Watchlist,
    );
    newsService
      .getListWatchListNews(
        {
          ...formatParams,
          WatchListId: newWatchListId,
          WatchListType: watchListType,
        },
        source,
      )
      .then(response => {
        dispatch(setFetching(false));
        const { items = [], totalCount, pageSize } = response;
        if (!items) return;
        dispatch({
          type: LOAD_MORE_NEWS,
          payload: {
            listWatchListNewsLoadMore: items || [],
            totalCount,
            pageSize,
          },
        });
      })
      .catch(err => dispatch(setFetching(false)));
    dispatch({
      type: FETCH_DATA,
      payload: {
        isFetching: true,
      },
    });
  };
}

function formatedParams(params) {
  let {
    Page,
    PageSize,
    KeyWord,
    FromDate,
    ToDate,
    WatchListId,
    SourceCode,
  } = params;
  const formatParams = {
    Page: Page || 1,
    PageSize: PageSize || 100,
    SourceCode: null,
  };
  if (KeyWord) formatParams.KeyWord = KeyWord;
  if (FromDate) {
    formatParams.FromDate = formatDate(FromDate, true);
  }
  if (ToDate) {
    formatParams.ToDate = formatDate(ToDate, false);
  }
  if (WatchListId) formatParams.WatchListId = WatchListId;
  if (SourceCode) {
    formatParams.SourceCode = SourceCode;
  }

  return formatParams;
}

function changeTrendIndex(typeTrend) {
  return {
    type: CHANGE_TREND_INDEX,
    payload: {
      typeTrend,
    },
  };
}

function renderPerformanceChart(performanceChartWidth, performanceChartHeight) {
  return {
    type: RENDER_PERFORMANCE_CHART,
    payload: {
      isDoneRender: true,
      performanceChartWidth,
      performanceChartHeight,
    },
  };
}

function updateCustomWatchlist(key, name, wlType = Const.watchListType.CUSTOM) {
  return dispatch => {
    const source = registerCancelTokenAxios.register(
      ConstCommon.listComponent.Watchlist,
    );

    userSettingService
      .renameWatchList(
        {
          [ConstSummary.listUserWatchList.WATCH_LIST_ID]: key,
          [ConstSummary.listUserWatchList.TEXT]: name,
        },
        source,
      )
      .then(res => {
        const type =
          wlType === Const.watchListType.CUSTOM
            ? UPDATE_MY_INDEX
            : UPDATE_MY_CW;
        dispatch({
          type,
          payload: {
            key,
            name,
          },
        });
      });
  };
}

function deleteMyCW(id) {
  return (dispatch, getState) => {
    const source = registerCancelTokenAxios.register(
      ConstCommon.listComponent.Watchlist,
    );

    userSettingService
      .deleteWatchList(
        { [ConstSummary.listUserWatchList.WATCH_LIST_ID]: id },
        source,
      )
      .then(res => {
        const { listMyCW } = getState()[REDUCER_NAME];
        let newListMyCW = listMyCW.filter(cwId => cwId !== id);
        if (!newListMyCW.length) {
          newListMyCW = ConstSummary.listCoveredWarrant;
        }
        const [watchListId] = newListMyCW;
        dispatch({
          type: DELETE_MY_CW,
          payload: {
            listMyCW: newListMyCW,
            watchListId,
          },
        });
      });
  };
}

function deleteMyIndex(key) {
  return (dispatch, getState) => {
    const source = registerCancelTokenAxios.register(
      ConstCommon.listComponent.Watchlist,
    );

    userSettingService
      .deleteWatchList(
        { [ConstSummary.listUserWatchList.WATCH_LIST_ID]: key },
        source,
      )
      .then(res => {
        dispatch(deleteUserWatchlist(key));
        const currentTab = getState()[REDUCER_NAME].currentTab;
        let currentMyIndex = getState()[REDUCER_NAME].currentMyIndex;
        let listMyIndex = getState()[REDUCER_NAME].listMyIndex;
        let watchListId = getState()[REDUCER_NAME].watchListId;
        let listMyIndexByKey = getState()[REDUCER_NAME].listMyIndexByKey;
        const watchListIdDefault = getState()[REDUCER_NAME].watchListIdDefault;

        listMyIndexByKey = omit(listMyIndexByKey, key);
        listMyIndex = listMyIndex.filter(item => {
          return item !== key;
        });

        if (currentMyIndex === key) {
          if (listMyIndex.length === 0) {
            if (watchListId === key) {
              watchListId = watchListIdDefault;
              currentMyIndex = ConstSummary.currentMyIndex;
              fetchData(dispatch, currentTab, watchListId);
            }
          } else {
            currentMyIndex = listMyIndex[0];
            if (watchListId === key) {
              watchListId = currentMyIndex;
              fetchData(dispatch, currentTab, watchListId);
            }
          }
        }

        dispatch({
          type: DELETE_MY_INDEX,
          payload: {
            currentMyIndex,
            watchListId,
            listMyIndex,
            listMyIndexByKey,
          },
        });
      });
  };
}

function changeListHideColumnIndex(listHideColumnIndex) {
  return (dispatch, getState) => {
    const userSetting = getUserSettingState(getState());
    const wlSetting = getWatchlistUserSetting(getState()) || {};
    wlSetting.hideColumns = listHideColumnIndex;
    const newUserSetting = {
      ...userSetting,
      watchListSetting: JSON.stringify(wlSetting),
    };
    if (JSON.stringify(wlSetting) !== userSetting.watchListSetting) {
      dispatch(callApiSystemSetting(newUserSetting));
    }

    dispatch({
      type: CHANGE_LIST_HIDE_COLUMN_INDEX,
      payload: {
        listHideColumnIndex,
      },
    });
  };
}

function setFilterNewValue(filterKey, filterValue) {
  return dispatch => {
    dispatch({
      type: SET_FILTER_NEW_VALUE,
      payload: {
        filterKey,
        filterValue,
      },
    });
  };
}

function setDateRangeOption(FromDate, ToDate) {
  return dispatch => {
    dispatch({
      type: SET_DATE_RANGE_OPTION,
      payload: {
        FromDate,
        ToDate,
      },
    });
  };
}

function setQueryNewValue(queryNews) {
  return dispatch => {
    dispatch({
      type: SET_QUERY_NEW_VALUE,
      payload: {
        queryNews,
      },
    });
  };
}

function notifyResizeColumnTable() {
  initialState.count++;
  return {
    type: RESIZE_COLUMN_TABLE,
    payload: {
      count: initialState.count,
    },
  };
}

function setFetching(payload = true) {
  return {
    type: SET_FETCHING,
    payload,
  };
}

function subscribeRealtimeTickData(data_) {
  const data = checkDataToDisplayNull(data_, true);
  return {
    type: SUBSCRIBE_REALTIME_DATA,
    payload: {
      data,
    },
  };
}

function toggleViewChart() {
  return {
    type: TOGGLE_VIEW_CHART,
  };
}

function fetchChartImage(organCode, theme) {
  return dispatch => {
    const source = registerCancelTokenAxios.register(
      ConstCommon.listComponent.Watchlist,
    );
    chartService
      .get6MonthsCandleStickChartImage({ organCode, theme }, source)
      .then(response => {
        if (response && response.items) {
          const item = response.items.length > 0 ? response.items[0] : '';

          dispatch({
            type: FETCH_DATA_CHART,
            payload: {
              organCode,
              item,
            },
          });
        }
      });
  };
}

function changeIdHover(organCode) {
  return {
    type: HOVER_ROW,
    payload: {
      organCode,
    },
  };
}

function notifySaveWatchList(isShow, messages = [], title = '') {
  return {
    type: NOTIFY_SAVE_WATCH_LIST,
    payload: {
      title,
      isShow,
      messages,
    },
  };
}

function checkExitTickerinWatchList(listTickerSummaryTable, organCode) {
  if (listTickerSummaryTable.find(item => item === organCode)) {
    return true;
  }
  return false;
}

function updateCWWatchListOrganCodes(code) {
  return (dispatch, getState) => {
    const listCwCodes = getState()[CW_REDUCER_NAME].codes;
    const watchListId = getState()[REDUCER_NAME].watchListId;
    if (listCwCodes.includes(code)) {
      dispatch(
        notifySaveWatchList(
          true,
          [I18n.t(`message.errorExistCWInWatchList.content`)],
          I18n.t(`message.errorExistCWInWatchList.title`),
        ),
      );
      return;
    }

    if (listCwCodes.length >= MAX_LENG_LIST_WATCH_LIST) {
      dispatch(
        notifySaveWatchList(
          true,
          [I18n.t(`message.errorLimitWatchList.content`)],
          I18n.t(`message.errorLimitWatchList.title`),
        ),
      );
      return;
    }

    const source = registerCancelTokenAxios.register(
      ConstCommon.listComponent.Watchlist,
    );

    userSettingService
      .updateWatchList(
        { watchListId, organCodes: listCwCodes.concat(code) },
        source,
      )
      .then(res => {
        coveredWarrantService
          .getCoveredWarrants({ Code: code }, source)
          .then(({ items }) => {
            if (items && items.length) {
              dispatch(addCoveredWarrant(items[0]));
            }
          });
      });
  };
}

function updateWatchList(organCode) {
  return (dispatch, getState) => {
    const currentTab = getState()[REDUCER_NAME].currentTab;
    const watchListId = getState()[REDUCER_NAME].watchListId;
    const listTickerSummaryTable = getState()[REDUCER_NAME]
      .listTickerSummaryTable;
    const listTickerTechnical = getState()[REDUCER_NAME].listTickerTechnical;

    if (checkExitTickerinWatchList(listTickerSummaryTable, organCode)) {
      dispatch(
        notifySaveWatchList(
          true,
          [I18n.t(`message.errorExitTickerInWatchList.content`)],
          I18n.t(`message.errorExitTickerInWatchList.title`),
        ),
      );
      return;
    }

    if (listTickerSummaryTable.length >= MAX_LENG_LIST_WATCH_LIST) {
      dispatch(
        notifySaveWatchList(
          true,
          [I18n.t(`message.errorLimitWatchList.content`)],
          I18n.t(`message.errorLimitWatchList.title`),
        ),
      );
      return;
    }

    const organCodes = [...listTickerSummaryTable, organCode];
    const source = registerCancelTokenAxios.register(
      ConstCommon.listComponent.Watchlist,
    );

    userSettingService
      .updateWatchList({ watchListId, organCodes }, source)
      .then(res => {
        const source = registerCancelTokenAxios.register(
          ConstCommon.listComponent.Watchlist,
        );

        summaryService
          .getTickerSummary({ OrganCode: organCode }, source)
          .then(({ items }) => {
            if (items) {
              const ticker = items.length > 0 ? items[0] : {};
              dispatch(addTicker(ticker, organCode));
            }
          });
      });
  };
}

function appendTickerToWatchlist(data) {
  return async dispatch => {
    const res = await userSettingService.appendTickerToWatchlist(data);
    if (res.errors && Array.isArray(res.errors)) {
      EventEmitter.dispatch(SET_ERROR, res.errors[0]);
    }

    return !res.errors;
  };
}

function addTickerTechnical(data, organCode) {
  return {
    type: ADD_TICKER_TECHNICAL,
    payload: {
      data,
      organCode,
    },
  };
}

function addTicker(data, organCode) {
  return {
    type: ADD_TICKER,
    payload: {
      data,
      organCode,
    },
  };
}

function deleteTicker(code, type) {
  return (dispatch, getState) => {
    const watchListId = getState()[REDUCER_NAME].watchListId;
    const listTickerSummaryTable = getState()[REDUCER_NAME]
      .listTickerSummaryTable;
    const listCoveredWarrantCodes = getState()[CW_REDUCER_NAME].codes;
    let codes = [];
    if (type === Const.watchListType.CUSTOM) {
      codes = listTickerSummaryTable.filter(item => item !== code);
    } else {
      codes = listCoveredWarrantCodes.filter(item => item !== code);
    }

    const source = registerCancelTokenAxios.register(
      ConstCommon.listComponent.Watchlist,
    );

    userSettingService
      .updateWatchList({ watchListId, organCodes: codes }, source)
      .then(res => {
        if (type === Const.watchListType.CUSTOM_CW) {
          dispatch(removeCoveredWarrant(code));
          dispatch(hideDeletePopup());
        } else {
          dispatch({
            type: DELETE_TICKER,
            payload: {
              organCode: code,
            },
          });
        }
      });
  };
}

function toggleConfirmPopupDelete(showConfirmPopupDelete, organCode) {
  return {
    type: TOGGLE_CONFIRM_POPUP_DELETE,
    payload: {
      organCode,
      showConfirmPopupDelete,
    },
  };
}

function confirmDeleteTicker(isApply, organCode, type) {
  return dispatch => {
    if (isApply) {
      dispatch(deleteTicker(organCode, type));
    } else {
      dispatch(toggleConfirmPopupDelete(false, ''));
    }
  };
}

function toggleConfirmPopupCreateWatchList(isShowPopup, title, messages = []) {
  return {
    type: TOGGLE_CONFIRM_POPUP_CREATE_WL,
    payload: {
      title,
      messages,
      isShowPopup,
    },
  };
}

function changeTableIndexSortState(sortState) {
  return {
    type: CHANGE_TABLE_INDEX_SORT_STATE,
    payload: sortState,
  };
}

const initialState = {
  // search add
  listTickerSummaryTable: [],
  listSummaryTableByTicker: {},
  summaryBidAskRealtimeData: {},

  // table derivative
  listTickerDerivativeTable: [],
  listDerivativeTableByTicker: {},
  // filter
  currentMyIndex: '',
  currentDefaultIndex: '',
  currentIndustry: '',
  currentDerivative: ConstSummary.currentDerivative,
  currentPutThrough: ConstSummary.currentPutThrough,

  listMyIndex: [],
  listDefaultIndex: [],
  listIndustry: [],
  listDerivative: ConstSummary.listDerivative,
  listPutThrough: ConstSummary.listPutThrough,

  listCoveredWarrant: ConstSummary.listCoveredWarrant,
  listCoveredWarrantByKey: ConstSummary.listCoveredWarrantByKey,
  currentCoveredWarrant: ConstSummary.currentCoveredWarrant,
  listMyCW: [],
  listMyCWByKey: {},

  listMyIndexByKey: {},
  listDefaultIndexByKey: {},
  listIndustryByKey: {},
  listDerivativeByKey: ConstSummary.listDerivativeByKey,
  listPutThroughByKey: ConstSummary.listPutThroughByKey,

  watchListId: '',
  watchListIdDefault: '',

  listTickerTechnical: [],
  listTechnicalByTicker: {},

  listTickerNews: [],
  listNewsByTicker: {},
  filterOption: {
    filterKey: null,
    filterValue: null,
  },
  dateRangeOption: {
    FromDate: null,
    ToDate: null,
  },
  totalPage: null,
  queryNews: null,
  isFetching: false,
  isChecked: false,

  typeTrendIndex: ConstSummary.index.AVERAGE_PRICE_DAILY,
  count: 0,
  data: null,
  countPerformanceChart: 0,

  viewChart:
    currentState.get(ConstCommon.listComponent.Watchlist, 'viewChart') || false,
  images: {},
  component: {},

  organCodeHover: '',

  showConfirmPopupDelete: false,
  organCodeDelete: '',

  createWl: {
    isShowPopup: false,
    title: '',
    messages: [],
  },

  listDataRealTimePutThrough: {},
  listPutThroughUpcom: [],
  listPutThroughHnx: [],
  listPutThroughHose: [],

  notifySaveListWatchList: {
    isShow: false,
    messages: [],
    title: '',
  },
  listHideColumnIndex: ConstSummary.listHideColumnIndex,
  currentTab: 1,
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case INIT_COMPONENT: {
      return {
        ...state,
        ...initialState,
        currentTab:
          currentState.get(ConstCommon.listComponent.Watchlist, 'currentTab') ||
          1,
        tableIndexSortState: {},
        sortedIds:
          currentState.get(ConstCommon.listComponent.Watchlist, 'sortedIds') ||
          null,
        listHideColumnIndex:
          currentState.get(
            ConstCommon.listComponent.Watchlist,
            'listHideColumnIndex',
          ) || ConstSummary.listHideColumnIndex,
        watchListId: +getQueryParams('watchListId') || initialState.watchListId,
      };
    }

    case UNMOUNT_COMPONENT: {
      return {};
    }

    case SUBSCRIBE_REALTIME_DATA_PUT_THROUGH:
      const { listDataRealTime } = action.payload;
      let newListPutThroughUpcom = state.listPutThroughUpcom;
      let newListPutThroughHnx = state.listPutThroughHnx;
      let newListPutThroughHose = state.listPutThroughHose;
      const mapList = {
        UpcomIndex: newListPutThroughUpcom,
        HNXIndex: newListPutThroughHnx,
        VNINDEX: newListPutThroughHose,
      };
      Object.keys(listDataRealTime).forEach(key => {
        listDataRealTime[key].forEach(ticker => {
          if (ticker.totalDealVolume === 0) {
            return;
          }
          const list = mapList[key];
          const prevTicker = list.find(
            item => item.organCode === ticker.organCode,
          );
          if (
            !prevTicker ||
            prevTicker.totalDealVolume >= ticker.totalDealVolume
          ) {
            return;
          }
          const dealVolume =
            ticker.totalDealVolume - prevTicker.totalDealVolume;
          const newRecord = {
            ...ticker,
            dealVolume,
            dealValue: dealVolume * ticker.dealPrice,
          };
          if (key === 'VNINDEX') {
            newListPutThroughHose = [newRecord, ...newListPutThroughHose];
          }

          if (key === 'HNXIndex') {
            newListPutThroughHnx = [newRecord, ...newListPutThroughHnx];
          }

          if (key === 'UpcomIndex') {
            newListPutThroughUpcom = [newRecord, ...newListPutThroughUpcom];
          }
        });
      });

      return {
        ...state,
        listPutThroughUpcom: newListPutThroughUpcom,
        listPutThroughHnx: newListPutThroughHnx,
        listPutThroughHose: newListPutThroughHose,
      };

    case CHANGE_TAB:
      const currentTab = action.payload.currentTab;
      const resetDateRangeOption = {
        FromDate: null,
        ToDate: null,
      };

      return { ...state, currentTab, dateRangeOption: resetDateRangeOption };

    case CHANGE_CURRENT_DATA: {
      const { oldWatchListId, watchListId } = action.payload;
      switch (oldWatchListId) {
        case state.currentMyIndex:
          return { ...state, sortedIds: null, currentMyIndex: watchListId };
        case state.currentDefaultIndex:
          currentState.add(
            ConstCommon.listComponent.Watchlist,
            'sortedIds',
            null,
          );
          return {
            ...state,
            sortedIds: null,
            currentDefaultIndex: watchListId,
          };
        case state.currentIndustry:
          return { ...state, sortedIds: null, currentIndustry: watchListId };
        case state.currentDerivative:
          return { ...state, sortedIds: null, currentDerivative: watchListId };
        case state.currentPutThrough:
          return { ...state, sortedIds: null, currentPutThrough: watchListId };
        default:
          return state;
      }
    }

    case DELETE_TICKER: {
      const { organCode } = action.payload;

      const newListSummaryTableByTicker = { ...state.listSummaryTableByTicker };
      delete newListSummaryTableByTicker[organCode];
      const newListTickerSummaryTable = [
        ...state.listTickerSummaryTable,
      ].filter(item => item !== organCode);

      return {
        ...state,
        listSummaryTableByTicker: newListSummaryTableByTicker,
        listTickerSummaryTable: newListTickerSummaryTable,
        showConfirmPopupDelete: false,
        organCodeDelete: '',
      };
    }
    case HIDE_DELETE_POPUP:
      return {
        ...state,
        showConfirmPopupDelete: false,
      };

    case ADD_TICKER_TECHNICAL: {
      const { organCode, data } = action.payload;

      return {
        ...state,
        organCodeHover: organCode,
        listTickerTechnical: addOrganCodeToList(organCode, [
          ...state.listTickerTechnical,
        ]),
        listTechnicalByTicker: {
          ...state.listTechnicalByTicker,
          [organCode]: data,
        },
      };
    }

    case ADD_TICKER: {
      const { data, organCode } = action.payload;
      const listData = checkDataToDisplayNull([data]);

      const ticker = listData && listData.length > 0 ? listData[0] : {};
      return {
        ...state,
        organCodeHover: organCode,
        listSummaryTableByTicker: {
          ...state.listSummaryTableByTicker,
          [getDataFollowKeyByDot(
            ticker,
            ConstSummary.index.ORGAN_CODE,
          )]: ticker,
        },
        listTickerSummaryTable: addOrganCodeToList(
          getDataFollowKeyByDot(ticker, ConstSummary.index.ORGAN_CODE),
          [...state.listTickerSummaryTable],
        ),
      };
    }

    case INITIAL_DATA_SUMMARY:
      return {
        ...state,
        listSummaryTableByTicker: {},
        listTickerSummaryTable: [],
      };

    case FETCH_LIST_SUMMARY:
      const listSummary = checkDataToDisplayNull(action.payload.listSummary);

      const listTickerSummaryTable = listSummary.map(item =>
        getDataFollowKeyByDot(item, ConstSummary.index.ORGAN_CODE),
      );
      const listSummaryTableByTicker = keyBy(
        listSummary,
        ConstSummary.index.ORGAN_CODE,
      );
      return {
        ...state,
        listSummaryTableByTicker: {
          ...state.listSummaryTableByTicker,
          ...listSummaryTableByTicker,
        },
        listTickerSummaryTable: [
          ...state.listTickerSummaryTable,
          ...listTickerSummaryTable,
        ],
      };

    case UPDATE_BID_ASK:
      return {
        ...state,
        summaryBidAskRealtimeData: {
          ...state.summaryBidAskRealtimeData,
          ...action.payload.data,
        },
      };

    case FETCH_LIST_DERIVATIVE: {
      const { listDerivative, derivativeId } = action.payload;

      const listTickerDerivativeTable = listDerivative.map(item =>
        getDataFollowKeyByDot(item, ConstSummary.derivative.DERIVATIVE_CODE),
      );
      const listDerivativeTableByTicker = keyBy(
        listDerivative,
        ConstSummary.derivative.DERIVATIVE_CODE,
      );

      return {
        ...state,
        listDerivativeTableByTicker,
        listTickerDerivativeTable,
        currentDerivative: derivativeId,
        watchListId: derivativeId,
      };
    }

    case UPDATE_LIST_DERIVATIVE:
      return {
        ...state,
        listDerivativeTableByTicker: {
          ...state.listDerivativeTableByTicker,
          ...action.payload,
        },
      };

    case FETCH_COVERED_WARRANT:
      return {
        ...state,
        currentCoveredWarrant: action.payload.coveredWarrantId,
        watchListId: action.payload.coveredWarrantId,
      };

    case FETCH_LIST_PUT_THROUGH:
      const {
        putThroughId,
        listPutThroughHnx,
        listPutThroughHose,
        listPutThroughUpcom,
      } = action.payload;

      return {
        ...state,
        currentPutThrough: putThroughId,
        watchListId: putThroughId,
        listPutThroughHnx,
        listPutThroughHose,
        listPutThroughUpcom,
      };

    case CREATE_WATCH_LIST: {
      const { watchListId, watchListName, type } = action.payload;
      if (type === Const.watchListType.CUSTOM) {
        return {
          ...state,
          watchListId,
          currentMyIndex: watchListId,
          listTickerSummaryTable: [],
          listSummaryTableByTicker: {},

          listTickerTechnical: [],
          listTechnicalByTicker: {},

          listMyIndex: [...state.listMyIndex, watchListId],
          listMyIndexByKey: {
            ...state.listMyIndexByKey,
            [watchListId]: {
              [ConstSummary.listUserWatchList.WATCH_LIST_ID]: watchListId,
              [ConstSummary.listUserWatchList.TEXT]: watchListName,
            },
          },
        };
      }

      return {
        ...state,
        watchListId,
        currentCoveredWarrant: watchListId,
        listMyCW: [...state.listMyCW, watchListId],
        listMyCWByKey: {
          ...state.listMyCWByKey,
          [watchListId]: {
            [ConstSummary.listUserWatchList.WATCH_LIST_ID]: watchListId,
            [ConstSummary.listUserWatchList.TEXT]: watchListName,
          },
        },
      };
    }

    case FETCH_MY_WATCH_LIST:
      const {
        listCustom,
        listCompany,
        listSector,
        listCW,
        watchListIdDefault,
        watchListId,
      } = action.payload;

      const {
        currentVal: currentMyIndex,
        listKey: listMyIndex,
        listByKey: listMyIndexByKey,
      } = formatList(
        listCustom,
        ConstSummary.currentMyIndex,
        watchListId,
        ConstSummary.listMyIndexByKey,
      );

      const {
        currentVal: currentCW,
        listKey: listMyCW,
        listByKey: listMyCWByKey,
      } = formatList(
        listCW,
        ConstSummary.currentCoveredWarrant,
        watchListId,
        ConstSummary.listCoveredWarrantByKey,
      );

      const {
        currentVal: currentDefaultIndex,
        listKey: listDefaultIndex,
        listByKey: listDefaultIndexByKey,
      } = formatList(listCompany, watchListIdDefault, watchListId);

      const {
        currentVal: currentIndustry,
        listKey: listIndustry,
        listByKey: listIndustryByKey,
      } = formatList(
        listSector,
        ConstSummary.currentIndustry,
        watchListId,
        ConstSummary.listIndustryByKey,
      );

      return {
        ...state,
        listMyIndex,
        listMyIndexByKey,
        currentMyIndex,

        currentCoveredWarrant: currentCW,
        listMyCW: [
          ...new Set([...ConstSummary.listCoveredWarrant, ...listMyCW]),
        ],
        listMyCWByKey: {
          ...listMyCWByKey,
          ...ConstSummary.listCoveredWarrantByKey,
        },

        listDefaultIndex,
        listDefaultIndexByKey,
        currentDefaultIndex,

        listIndustry,
        listIndustryByKey,
        currentIndustry,

        watchListId,
        watchListIdDefault,
      };

    case CHANGE_WATCH_LIST_ID:
      return { ...state, watchListId: action.payload.watchListId };

    case FETCH_LIST_NEWS: {
      const { listWatchListNews, totalCount, pageSize } = action.payload;
      const totalPage = Math.ceil(totalCount / pageSize);
      const listTickerNews = listWatchListNews.map(item =>
        getDataFollowKeyByDot(item, ConstNews.listColumn.NEWS_ID),
      );
      const listNewsByTicker = keyBy(
        listWatchListNews,
        ConstNews.listColumn.NEWS_ID,
      );

      return {
        ...state,
        listTickerNews,
        listNewsByTicker,
        totalPage,
      };
    }

    case LOAD_MORE_NEWS:
      const {
        listWatchListNewsLoadMore,
        totalCount,
        pageSize,
      } = action.payload;
      const listTickerNewsLoadMore = listWatchListNewsLoadMore.map(item =>
        getDataFollowKeyByDot(item, ConstNews.listColumn.NEWS_ID),
      );
      const listNewsByTickerLoadMore = keyBy(
        listWatchListNewsLoadMore,
        ConstNews.listColumn.NEWS_ID,
      );
      const totalPage = Math.ceil(totalCount / pageSize);
      return {
        ...state,
        listTickerNews: [...state.listTickerNews, ...listTickerNewsLoadMore],
        listNewsByTicker: {
          ...state.listNewsByTicker,
          ...listNewsByTickerLoadMore,
        },
        isFetching: false,
        totalPage,
      };

    case FETCH_DATA:
      const { isFetching } = action.payload;
      return {
        ...state,
        isFetching,
      };

    case CHANGE_TREND_INDEX:
      const { typeTrend } = action.payload;

      return {
        ...state,
        typeTrendIndex: typeTrend,
      };

    case RENDER_PERFORMANCE_CHART:
      const isDoneRender = action.payload.isDoneRender;
      const performanceChartWidth = action.payload.performanceChartWidth;
      const performanceChartHeight = action.payload.performanceChartHeight;

      return {
        ...state,
        isDoneRender,
        performanceChartWidth,
        performanceChartHeight,
      };

    case UPDATE_MY_INDEX:
      const { key, name } = action.payload;
      const tmpListMyIndexByKey = { ...state.listMyIndexByKey };
      tmpListMyIndexByKey[key][ConstSummary.listUserWatchList.TEXT] = name;

      return { ...state, listMyIndexByKey: tmpListMyIndexByKey };
    case UPDATE_MY_CW:
      return {
        ...state,
        listMyCWByKey: {
          ...state.listMyCWByKey,
          [action.payload.key]: {
            ...state.listMyCWByKey[action.payload.key],
            [ConstSummary.listUserWatchList.TEXT]: action.payload.name,
          },
        },
      };
    case DELETE_MY_INDEX:
      return {
        ...state,
        currentMyIndex: action.payload.currentMyIndex,
        watchListId: action.payload.watchListId,
        listMyIndex: action.payload.listMyIndex,
        listMyIndexByKey: action.payload.listMyIndexByKey,
      };

    case DELETE_MY_CW:
      return {
        ...state,
        watchListId: action.payload.watchListId,
        listMyCW: action.payload.listMyCW,
        currentCoveredWarrant: action.payload.watchListId,
      };

    case CHANGE_LIST_HIDE_COLUMN_INDEX:
      const { listHideColumnIndex } = action.payload;

      return { ...state, listHideColumnIndex: [...listHideColumnIndex] };

    case SET_FILTER_NEW_VALUE:
      const { filterKey, filterValue } = action.payload;
      const filterOption = {
        ...state.filterValue,
        filterKey,
        filterValue,
      };
      return {
        ...state,
        filterOption,
      };

    case SET_DATE_RANGE_OPTION:
      const { FromDate, ToDate } = action.payload;
      const dateRangeOption = {
        ...state.dateRangeOption,
        FromDate,
        ToDate,
      };
      return {
        ...state,
        dateRangeOption,
      };

    case SET_QUERY_NEW_VALUE:
      const { queryNews } = action.payload;
      return {
        ...state,
        queryNews,
      };

    case RESIZE_COLUMN_TABLE:
      const { count } = action.payload;

      return { ...state, count };

    case FETCH_DATA_PERFORMANCE_REALTIME:
      const { data, countPerformanceChart } = action.payload;

      return { ...state, data, countPerformanceChart };

    case SUBSCRIBE_REALTIME_DATA:
      action.payload.data.forEach(item => {
        if (state.listSummaryTableByTicker[item.organCode]) {
          state.listSummaryTableByTicker[item.organCode] = {
            ...state.listSummaryTableByTicker[item.organCode],
            priceInfo: item,
            performance: {
              ...state.listSummaryTableByTicker[item.organCode].performance,
              percentPriceChange1Day: item.percentPriceChange,
            },
          };
        }
      });

      return { ...state };

    case SET_FETCHING:
      return {
        ...state,
        isFetching: action.payload,
      };

    case INITIAL_DATA_TECHNICAL:
      return {
        ...state,
        listTickerTechnical: [],
        listTechnicalByTicker: {},
      };

    case TOGGLE_VIEW_CHART:
      currentState.add(
        ConstCommon.listComponent.Watchlist,
        'viewChart',
        !state.viewChart,
      );
      return {
        ...state,
        viewChart: !state.viewChart,
      };

    case FETCH_DATA_CHART:
      const { item: imageSrc, organCode: imageCode } = action.payload;
      return {
        ...state,
        images: { ...state.images, [imageCode]: imageSrc },
      };

    case INITIAL_LIST_DATA_CHART:
      return {
        ...state,
        images: {},
      };

    case CHANGE_SIZE_COMPONENT:
      return {
        ...state,
        component: action.payload,
      };

    case HOVER_ROW:
      return {
        ...state,
        organCodeHover: action.payload.organCode,
      };

    case TOGGLE_CONFIRM_POPUP_DELETE:
      return {
        ...state,
        showConfirmPopupDelete: action.payload.showConfirmPopupDelete,
        organCodeDelete: action.payload.organCode,
      };

    case TOGGLE_CONFIRM_POPUP_CREATE_WL:
      return {
        ...state,
        createWl: action.payload,
      };
    case CHANGE_TABLE_INDEX_SORT_STATE:
      return {
        ...state,
        tableIndexSortState: action.payload,
      };
    case SET_SORTED_IDS:
      currentState.add(
        ConstCommon.listComponent.Watchlist,
        'sortedIds',
        action.payload,
      );
      return {
        ...state,
        sortedIds: action.payload,
      };

    case NOTIFY_SAVE_WATCH_LIST:
      const { title, isShow, messages } = action.payload;

      return {
        ...state,
        notifySaveListWatchList: {
          ...state.notifySaveListWatchList,
          title,
          isShow,
          messages,
        },
      };

    default:
      return state;
  }
}

function fetchData(dispatch, currentTab, watchListId) {
  registerCancelTokenAxios.delete(ConstCommon.listComponent.Watchlist);

  dispatch(changeWatchListId(watchListId));
  const isDerivative = Object.keys(ConstSummary.listDerivativeByKey).includes(
    watchListId,
  );
  if (isDerivative) {
    dispatch(fetchListDerivative(watchListId));
  } else if (watchListId === ConstSummary.listPutThroughByKey.PUT_THROUGH.key) {
    dispatch(fetchListPutThrough(watchListId));
  } else {
    switch (currentTab) {
      case 1:
      case 2:
      case 5:
      case 4:
        dispatch(fetchListSummary(watchListId));
        break;
      case 3:
        dispatch(fetchListNewsData({}, watchListId));
        break;
      default:
        break;
    }
  }
}

reducerRegistry.register(REDUCER_NAME, reducer);

function getUserWatchListByTypeCode(listUserWatchList) {
  const result = {
    listCustom: [],
    listCompany: [],
    listSector: [],
    listCW: [],
  };
  listUserWatchList.forEach(item => {
    if (item.typeCode === Const.watchListType.CUSTOM) {
      result.listCustom.push(item);
    }
    if (item.typeCode === Const.watchListType.SECTOR) {
      result.listSector.push(item);
    }
    if (item.typeCode === Const.watchListType.COMPANY_GROUP) {
      result.listCompany.push(item);
    }
    if (item.typeCode === Const.watchListType.CUSTOM_CW) {
      result.listCW.push(item);
    }
  });

  return result;
}

function addOrganCodeToList(organCode, list) {
  if (!includes(list, organCode)) {
    list.push(organCode);
  }
  return list;
}

function hideFetching(getState, dispatch) {
  const currentMyIndex = getState()[REDUCER_NAME].currentMyIndex;
  const watchListId = getState()[REDUCER_NAME].watchListId;
  if (watchListId !== currentMyIndex) {
    dispatch(setFetching(false));
  }
}

function checkDataToDisplayNull(listSummary, dataRealTime = false) {
  const listColumn = dataRealTime
    ? getDataKeyRealTime(
        ConstSummary.listDisplayNullWhenTotalVolumeEqualZeroInSummary,
      )
    : ConstSummary.listDisplayNullWhenTotalVolumeEqualZeroInSummary;

  listSummary.forEach(item => {
    const volume = getDataFollowKeyByDot(item, listColumn.TOTAL_MATCH_VOLUME);
    if (!volume) {
      Object.values(listColumn).forEach(strKey => {
        setDataFollowKeyByDot(item, strKey, null);
      });
    }
  });

  return listSummary;
}

// get only last part after the dot.
// e.g. priceInfo.matchPrice => matchPrice
function getDataKeyRealTime(listDataKey) {
  let dataKeys = cloneDeep(listDataKey);
  Object.keys(dataKeys).forEach(key => {
    const temp = dataKeys[key].split('.');
    dataKeys[key] = temp[temp.length - 1];
  });
  return dataKeys;
}

function formatList(list, defaultVal, watchListId, appendListByKey = {}) {
  let currentVal = defaultVal;
  let listKey = [];
  let listByKey = {};

  list.forEach(item => {
    if (
      getDataFollowKeyByDot(
        item,
        ConstSummary.listUserWatchList.WATCH_LIST_ID,
      ) === watchListId
    ) {
      currentVal = watchListId;
    }
    const key = getDataFollowKeyByDot(
      item,
      ConstSummary.listUserWatchList.WATCH_LIST_ID,
    );

    listKey.push(key);
    listByKey[key] = item;
  });

  listByKey = {
    ...listByKey,
    ...appendListByKey,
  };

  return {
    currentVal,
    listKey,
    listByKey,
  };
}
